// TODO: Fix attributes misspelling when API fixes it.
export const searchResultGetParser = data => data.map(({ id, atributes: { name, photo, level } }) => ({
  id,
  name,
  level,
  photo,
}));

export function prepareInviteFriendsData(userList) {
  const users = [];
  const emails = [];

  userList.forEach(data => (data.isNewUser ? emails.push(data.name) : users.push(data.id)));
  return {
    users,
    emails,
  };
}



// WEBPACK FOOTER //
// ./src/api/dataParsers.js